import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';
import banner1 from '../../images/banner1.jpg';
import banner2 from '../../images/banner2.jpg';
import banner3 from '../../images/banner3.jpg';
import aboutimg from '../../images/home_about.jpg';
import logo1 from '../../images/logo_Parle-G-Gluco-logo.webp';
import logo2 from '../../images/logo_Parle-G-Gluco-logo.webp';
import logo3 from '../../images/logo_Parle-G-Gluco-logo.webp';
import logo4 from '../../images/logo_Parle-G-Gluco-logo.webp';
import logo5 from '../../images/logo_Parle-G-Gluco-logo.webp';
import logo6 from '../../images/logo_Parle-G-Gluco-logo.webp';
import logo7 from '../../images/logo_Parle-G-Gluco-logo.webp';





const OwlCarouselBanner = () => {
  return (
    <>
      {/* ==== Banner Section Start ==== */}
      <section id="homebanner_secdesktop" className="banner">
        <OwlCarousel
          className="owl-theme"
          loop
          margin={10}
          nav
          autoplay
          autoplayTimeout={3000}
          items={3}
        >
          <div className="item">
          <div className="col-xl-12 col-md-12">
                <div className="service-card style2">
                  <div className="box-thumb">
                    <img
                      src={banner1}
                      alt="Service 1"
                    />
                  </div>
                  <div className="box-icon">
                    <img
                      src="/assets/img/icon/service-icon/service-card-icon1-1.svg"
                      alt="Icon 1"
                    />
                  </div>
                  <div className="box-content">
                    <h3 className="box-title">
                      <a href="/about">Healthy Foods</a>
                    </h3>
                    <p className="box-text">
                      Share stories and experiences from current volunteers to
                      inspire others to join.
                    </p>
                    <a href="/about" className="th-btn">
                      Learn More
                      <i className="fas fa-arrow-up-right ms-2" />
                    </a>
                  </div>
                </div>
              </div>
          </div>

          <div className="item">
          <div className="col-xl-12 col-md-12">
                <div className="service-card style2">
                  <div className="box-thumb">
                    <img
                      src={banner2}
                      alt="Service 1"
                    />
                  </div>
                  <div className="box-icon">
                    <img
                      src="/assets/img/icon/service-icon/service-card-icon1-1.svg"
                      alt="Icon 1"
                    />
                  </div>
                  <div className="box-content">
                    <h3 className="box-title">
                      <a href="/about">Healthy Foods</a>
                    </h3>
                    <p className="box-text">
                      Share stories and experiences from current volunteers to
                      inspire others to join.
                    </p>
                    <a href="/about" className="th-btn">
                      Learn More
                      <i className="fas fa-arrow-up-right ms-2" />
                    </a>
                  </div>
                </div>
              </div>
          </div>

          <div className="item">
          <div className="col-xl-12 col-md-12">
                <div className="service-card style2">
                  <div className="box-thumb">
                    <img
                      src={banner3}
                      alt="Service 1"
                    />
                  </div>
                  <div className="box-icon">
                    <img
                      src="/assets/img/icon/service-icon/service-card-icon1-1.svg"
                      alt="Icon 1"
                    />
                  </div>
                  <div className="box-content">
                    <h3 className="box-title">
                      <a href="/about">Healthy Foods</a>
                    </h3>
                    <p className="box-text">
                      Share stories and experiences from current volunteers to
                      inspire others to join.
                    </p>
                    <a href="/about" className="th-btn">
                      Learn More
                      <i className="fas fa-arrow-up-right ms-2" />
                    </a>
                  </div>
                </div>
              </div>
          </div>
       
         
        </OwlCarousel>
      </section>
      {/* ==== Banner Section End ==== */}
    </>
  );
};

export default OwlCarouselBanner;
